// extracted by mini-css-extract-plugin
export default {"main-layout":"OgmJf","layout-body":"vHgm8","layout-main":"J35Yq","micro-app-container":"Giv1h","placeholder":"IJlOP"};